module.exports = __webpack_public_path__ + "img/pamphlet_thumb02@3x.78ccaa7b.png";